import { getInstance } from "./index";
import { baseGuard } from "@/auth/baseGuard";

/*
    Denne vil sjekke om innlogget bruker er en admin.
*/
export const adminGuard = (to, from, next) => {
    const authService = getInstance();

    async function fn() {
        baseGuard(to, from, next);
        /*
            Sjekke om brukeren er autentisert, verifisert, og admin.
        */
        if (!isAdmin(authService.user.email)) {
            return next({ name: "Home" });
        }

        return next();
    }

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
        return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn();
        }
    });
};

export const isAdmin = (email) => {
    const admins = [
        'terje@getacademy.no',
        'rikard@getacademy.no',
        'bjornarj@getacademy.no',
        'christofferh@getacademy.no',
        'emil@getacademy.no',
        'stella@getacademy.no',
    ];

    return admins.includes(email);
}